import { Navigate, useParams } from 'react-router-dom';

import { useGetPresentaciones } from '@/shared/actions/erp';
import { LoaderComponent } from '@/shared/components/ui';
import { SavePresentacion } from '../../shared/savePresentaciones';
import { useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';

export interface UpdatePresentacionesPageInterface {}

const UpdatePresentacionesPage: React.FC<UpdatePresentacionesPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_presentacion)

  const { id } = useParams();
  const { data, isLoading } = useGetPresentaciones(id!);

  if (isLoading) return <LoaderComponent />;
  if (!data?.data?.id_presentacion) return <Navigate to="/inventario/presentacion" />;

  return <SavePresentacion titlePage="Editar Tipo del producto" editPresentacion={data.data} />;
};

export default UpdatePresentacionesPage;
